let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8rk6s")).then(() => parcelRequire('i0mY9'));